var _excluded = ["icon", "iconColor", "image", "title", "titleColor", "text", "link", "isCentered", "hasMobileBottomText"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import IconAtm from "../../atoms/IconAtm";
import TextAtm from "../../atoms/TextAtm";
import UnderlineLinkAtm from "../../atoms/UnderlineLinkAtm";
import PushOrg from "../../organisms/PushOrg";
import Picture from "../../quarks/Picture";
var breakpointValue = "medium";
var iconWrapperBackground = "background";
var Wrapper = styled.div.withConfig({
  componentId: "sc-yfql14-0"
})(function (_ref) {
  var $isCentered = _ref.$isCentered,
    $hasImage = _ref.$hasImage,
    $hasMobileBottomText = _ref.$hasMobileBottomText;
  return css(["display:flex;", " ", " ", "{flex-direction:column;}", "{", "}"], $hasImage && css(["> *:first-child{flex-shrink:0;}"]), $isCentered && css(["flex-direction:column;align-items:center;text-align:center;"]), breakpoint(breakpointValue), breakpoint("small", breakpointValue), $hasMobileBottomText && css(["flex-direction:column;"]));
});
var IconWrapper = styled.div.withConfig({
  componentId: "sc-yfql14-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["display:inline-block;padding:", ";border-radius:", ";background-color:", ";box-shadow:", ";"], space(1.5), getBorderRadius(theme, "large"), getColor(theme, iconWrapperBackground), getBoxShadow(theme, "large"));
});
function ItemDescriptionMol(_ref3) {
  var icon = _ref3.icon,
    iconColor = _ref3.iconColor,
    image = _ref3.image,
    title = _ref3.title,
    titleColor = _ref3.titleColor,
    text = _ref3.text,
    link = _ref3.link,
    isCentered = _ref3.isCentered,
    hasMobileBottomText = _ref3.hasMobileBottomText,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  var imgJsx;
  if (icon) {
    imgJsx = /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
      value: iconWrapperBackground
    }, "src" in icon ? /*#__PURE__*/React.createElement(Picture, {
      srcData: icon.src,
      alt: icon.alt
    }) : /*#__PURE__*/React.createElement(IconAtm, {
      icon: icon,
      sizeSpace: 2,
      color: iconColor
    })));
  } else if (image) {
    imgJsx = /*#__PURE__*/React.createElement(Picture, {
      srcData: image.src,
      alt: image.alt
    });
  } else {
    imgJsx = null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $hasImage: !!imgJsx,
    $isCentered: !!isCentered,
    $hasMobileBottomText: !!hasMobileBottomText
  }, restProps), imgJsx ? /*#__PURE__*/React.createElement(PushOrg, {
    rightSpace: isSmallOnly && !isCentered && !hasMobileBottomText ? 3 : 0,
    bottomSpace: isSmallOnly && !isCentered && !hasMobileBottomText ? 0 : 4
  }, imgJsx) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "medium4_s",
    pushSpace: 1.5,
    color: titleColor
  }, title), text, link ? /*#__PURE__*/React.createElement(UnderlineLinkAtm, {
    to: link.to,
    href: link.href,
    onClick: link.onClick,
    title: link.title,
    typography: "medium1_h",
    openInNewTab: link.openInNewTab
  }, link.text) : null));
}
export default ItemDescriptionMol;